import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { FormControl } from '@angular/forms';
import { Actions, ofActionDispatched, Store } from '@ngxs/store';
import { FetchMyPinnedModules } from 'app/library/my-profile-pinned-modules/actions';
import { TagMultiSelectService } from 'app/library/tag/services/multi-select.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize, take, tap } from 'rxjs/operators';
import { ModuleUserExtended } from '../../../module-user/models/module-user.extended.model';

export class PinnedModuleDataSource implements DataSource<ModuleUserExtended> {
    private _data: ModuleUserExtended[];
    statusCtrl = new FormControl({ value: '', disabled: false });

    private _loadingSubject = new BehaviorSubject<boolean>(false);

    public loading$ = this._loadingSubject.asObservable();

    get data() {
        return this._data;
    }

    constructor(private _filteredUser$: Observable<ModuleUserExtended[]>, private _store: Store, private _action$: Actions, public tagMultiSelectService: TagMultiSelectService) {}

    connect(collectionViewer: CollectionViewer): Observable<ModuleUserExtended[]> {
        return this._filteredUser$.pipe(
            tap((filteredUsers) => {
                if (filteredUsers && filteredUsers.length) {
                }
                this._data = filteredUsers;
            })
        );
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this._loadingSubject.complete();
    }

    loadPinnedModules(
        category: string,
        search?: string,
        sortBy?: string,
        sortOrder?: string,
        pageSize?: number,
        pageNumber?: number,
        participantId?: string,
        tag?: number[],
        isParticipant?: boolean,
        isManager?: boolean
    ): void {
        this._loadingSubject.next(true);
        this._store.dispatch(
            new FetchMyPinnedModules({
                category,
                search,
                sortBy,
                sortOrder,
                pageSize,
                pageNumber: pageNumber,
                participantId: participantId,
                tag,
                isParticipant,
                isManager,
            })
        );

        this._action$
            .pipe(
                ofActionDispatched(FetchMyPinnedModules),
                finalize(() => this._loadingSubject.next(false)),
                take(1)
            )
            .subscribe();
    }
}
